import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useNavigate, useLocation } from 'react-router';
import { Link } from "react-router-dom";

import Header from '@/views/components/Header/Header';
import Footer from '@/views/components/Footer/Footer';
import Question from '@/views/components/SimpleTextAdivse/Question/Question';
import Comments from '@/views/components/SimpleTextAdivse/Comments/Comments';
import DeleteIcon from '@/assets/icons/simpleTextAdvices/delete_icon.svg';
import ModalDeleteQuestion from '@/views/components/SimpleTextAdivse/Modals/ModalDeleteQuestion';
import api from '@/services/api';
import { CheckPermission } from '@/utils/permissions/permissions';

import styles from '@/views/pages/SimpleTextAdvice/SimpleTextAdvice.module.scss';

const SimpleTextAdvice = () => {
	const [ question, setQuestion ] = useState(null);
	const [ nextCategoryId, setNextCategoryId ] = useState(null);
	const [ showModalDelete, setShowModalDelete ] = useState(false);
	const [ backButton, setBackButton ] = useState(''); 
	
	const {search} = useLocation();
	const navigate = useNavigate();

	const { id: questionId } = useParams();

	const user = useSelector((state) => state.auth.user);
	const dict = useSelector(state => state.app.dict);

	const userRole = user && user.role;

	const getBackButton = () => {
		if (backButton === 'admin-advices'){
			return	<Link className='button__transparent'
				to='/simple-text-advices-admin'><div className={ `icon-arrow-left-full` } />{dict.simpleTextAdvices.advice.backAdmin} 
			</Link>;
		}
		else if(backButton === 'my-advices') {
			return	<Link className='button__transparent'
				to='/simple-text-my-advices'><div className={ `icon-arrow-left-full` } />{dict.simpleTextAdvices.advice.backMyAdvices}
			</Link>;
		} else {
			return	<Link className='button__transparent'
				to='/simple-text-advices'><div className={ `icon-arrow-left-full` } />{dict.simpleTextAdvices.advice.backAdvices}
			</Link>;
		}
	};

	const getQuestion = async (id) => {
		const {data} = await api.get(`/questions/${id}`);

		setNextCategoryId(data.nextInCategoryId);
		setQuestion(data);
	};

	const handleClose = () => {
		setShowModalDelete(false);
	};
	useEffect(() => {
		if(questionId) {
			getQuestion(questionId);
		}
	}, [ questionId ]);

	useEffect(() => {
		if(search.includes('my-advices')) {
			setBackButton('my-advices');
			const url = location.pathname.replace('?my-advices', '');
			navigate(url, {replace: true});
		} else if (search.includes('admin-advices')) {
			setBackButton('admin-advices');
			const url = location.pathname.replace('?admin-advices', '');
			navigate(url, {replace: true});
		}
	}, []);

	return (
		<>
			{showModalDelete && <ModalDeleteQuestion 
				showModalDelete={ showModalDelete }
				setShowModalDelete={ setShowModalDelete }
				handleClose={ handleClose }
				id={ question.id }
			/>}
			<Header narrow={ false } />
			<div className={ styles['advise__container'] }>
				<div className={ styles['advise__buttonTop'] }>
					{getBackButton()}
					<div>
						{nextCategoryId && 
						<Link className='button__transparent'
							to={ `/simple-text-advice/${nextCategoryId}` }>
							{dict.simpleTextAdvices.advice.nextAdvice} 
							<div className={ `icon-arrow-right-full` } />
						</Link>
						}
					</div>
				</div>
				{question && <Question question={ question }
					getQuestion={ getQuestion } />}
				{question && 
				<Comments 
					comments={ question.comments }
					show={ question.answer }
					questionId={ question.id }
					getQuestion={ getQuestion }
					showActionButtons={ !question.closed  }
				/>
				}
				{CheckPermission("canManageQuestions", userRole) && <div className={ styles['advise__delete'] }>
					<button className={ styles['advise__delete__btn'] }
						onClick={ () => setShowModalDelete(true) }>
						<img src={ DeleteIcon } />{dict.simpleTextAdvices.advice.delete} 
					</button>
				</div>}
			</div>
			<Footer />
		</>
	);
};

export default SimpleTextAdvice;